import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingCost6 = props => (
    <section id="outsourcing-cost-section6" className="my pt-5 black-bg">
        <div className='white-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingCost:section-6.title')}</h2>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingCost:section-6.text"
                    components={{
                        br: <br />,
                        outsourcingService: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing.path')} className="link" />
                    }}
                />
            </p>
        </Container>
    </section>
);

export default OutsourcingCost6;
